<script>
import { h, getCurrentInstance, computed } from '@vue/composition-api'
export default {
    setup () {
        const vm = getCurrentInstance().proxy
        const subAction = computed(() => vm.$route.meta.subAction)
        return () =>
            h('b-badge', {
                props: {
                    variant: 'primary'
                },
                class: {
                    'cursor-pointer': true
                },
                on: {
                    click: subAction.value.handleClick
                }
            }, vm.$t(subAction.value.text))
    }
}
</script>

<style>

</style>
